import {
  Component,
  ElementRef,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import { CredentialResponse, PromptMomentNotification } from 'google-one-tap';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { User } from '../../models/user.model';
import { UserRoleEnum } from '../../enums/user-role-enum';

@Component({
  selector: 'google-auth',
  standalone: true,
  imports: [],
  templateUrl: './google-auth.component.html',
  styleUrl: './google-auth.component.css',
})
export class GoogleAuthComponent implements OnInit {
  @ViewChild('gbutton') gbutton: ElementRef = new ElementRef({});
  googleCientId = environment.GoogleClientId;

  returnUrl: string = '';
  loggedUser: User = new User();

  constructor(
    private ngZone: NgZone,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) {}
  ngOnInit(): void {
    this.returnUrl =
      this.route.snapshot.queryParams['returnUrl'] ||
      environment.DefaultReturnUrl;
  }

  ngAfterViewInit(): void {
    // @ts-ignore
    window.google.accounts.id.initialize({
      itp_support: true,
      client_id: this.googleCientId,
      callback: this.handleCredentialResponse.bind(this),
      auto_select: false,
      cancel_on_tap_outside: true,
    });
    // @ts-ignore
    window.google.accounts.id.renderButton(this.gbutton.nativeElement, {
      type: 'standard',
      theme: 'outline',
      size: 'large',
      text: 'continue_with',
      shape: 'pill',
      logo_alignment: 'center',
      width: 300,
    });

    this.gbutton.nativeElement.classList.add('google-button'); // set google auth button width to 100%
    // @ts-ignore
    window.google.accounts.id.prompt(
      (notification: PromptMomentNotification) => {
        if (notification.isDisplayMoment()) {
          console.log('Google One Tap is displayed');
        }
      }
    );
  }

  async handleCredentialResponse(response: CredentialResponse) {
    this.ngZone.run(() => {
      if (response.credential) {
        // Verify the token on the backend
        // Use the token to authenticate the user
        //this.spinner.show();
        this.authService
          .googleAuthenticate({ token: response.credential })
          .subscribe(
            (response) => {
              this.spinner.hide();
              this.loggedUser = this.authService.CurrentUserValue;
              this.returnUrl =
                this.loggedUser.role == UserRoleEnum.MasterAdmin
                  ? environment.DefaultRetrunUrlForMasterAdmin
                  : this.returnUrl;
              this.router.navigateByUrl(this.returnUrl);
            },
            (error: any) => {
              this.toastr.error(error.error.message.Text, 'Login');
              this.spinner.hide();
              console.error(error.error.message);
            }
          );
      }
    });
  }
}
